<button (click)="convertScript()"> Generate</button>

<!-- INPUT -->
<div class="input">
  <textarea [(ngModel)]="query" placeholder="Paste your db scheme here"></textarea>
</div>